import Cookies from 'js-cookie'

const TokenKey = 'lcytoken'

export function getToken() {
    // return "123"
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token, {expires: 365})
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function tokenNotExists() {
    return Cookies.get(TokenKey) === undefined || Cookies.get(TokenKey) === ""
}
